import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getUsersFromImportRequests } from 'services/import-requests'
import { ImportRequestQueryKeys } from 'services/import-requests/queryKeys'
import type { GetImportRequestFilterUsersResponse } from 'services/import-requests/types'
import type { ApiErrorResponse } from 'services/types'

export const useGetUsersFromImportRequests = (
  options?: Omit<UseQueryOptions<GetImportRequestFilterUsersResponse, ApiErrorResponse>, 'queryKey'>
) =>
  useQuery<GetImportRequestFilterUsersResponse, ApiErrorResponse>({
    queryKey: ImportRequestQueryKeys.FilterUsers(),
    queryFn: ({ signal }) => getUsersFromImportRequests({ signal }),
    ...options
  })
